'use strict';

exports.__esModule = true;
exports.EmptyStateDescription = exports.EmptyStateTitle = exports.EmptyStateIcon = exports.EmptyStateBox = undefined;

var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  padding: ', ';\n'], ['\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 100%;\n  padding: ', ';\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  font-size: 30px;\n  line-height: 1;\n  margin-bottom: ', ';\n'], ['\n  font-size: 30px;\n  line-height: 1;\n  margin-bottom: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-weight: ', ';\n  font-size: 16px;\n  margin-bottom: ', ';\n'], ['\n  color: ', ';\n  font-weight: ', ';\n  font-size: 16px;\n  margin-bottom: ', ';\n']),
    _templateObject4 = _taggedTemplateLiteralLoose(['\n  color: ', ';\n  font-size: 13px;\n  line-height: 1.5;\n'], ['\n  color: ', ';\n  font-size: 13px;\n  line-height: 1.5;\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _spacing = require('../../../styles/spacing');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

// Primitiv-Bibliothek (2026-06): Leer-Zustand-Primitiv (EmptyState).
// Zentrierter Block (Icon/Emoji + Titel + Beschreibung) — die zentrale „keine
// Treffer / keine Daten"-Darstellung, u.a. als noDataComponent von
// react-data-table-component (ManageStudents 0-Treffer). Token-Aufloesung mit
// Fallback-Kette analog Card/Alert (greift nur ohne vollstaendigen ThemeProvider).
// Layout-Overrides (z.B. Mindesthoehe in einer bestimmten Tabelle) via styled(EmptyState).

var EmptyStateBox = exports.EmptyStateBox = _styledComponents2.default.div(_templateObject, (0, _spacing.space)(40, 24));

var EmptyStateIcon = exports.EmptyStateIcon = _styledComponents2.default.div(_templateObject2, (0, _spacing.space)(10));

var EmptyStateTitle = exports.EmptyStateTitle = _styledComponents2.default.div(_templateObject3, function (_ref) {
  var theme = _ref.theme;
  return theme.secondary || '#183a64';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontWeightUpperBold || 600;
}, (0, _spacing.space)(4));

var EmptyStateDescription = exports.EmptyStateDescription = _styledComponents2.default.div(_templateObject4, function (_ref3) {
  var theme = _ref3.theme;
  return theme.textColor69 || '#696969';
});